export enum Currency {
    AUD = 'AUD',
    CAD = 'CAD',
    CHF = 'CHF',
    DKK = 'DKK',
    EUR = 'EUR',
    GBP = 'GBP',
    HKD = 'HKD',
    JPY = 'JPY',
    MXN = 'MXN',
    NOK = 'NOK',
    SGD = 'SGD',
    USD = 'USD',
}

export enum CurrencySymbol {
    AUD = '$',
    CAD = '$',
    CHF = 'Fr.',
    DKK = 'Kr.',
    EUR = '€',
    GBP = '£',
    HKD = '$',
    JPY = '¥',
    MXN = '$',
    NOK = 'kr',
    SGD = 'S$',
    USD = '$',
}

const unitMultiplier: { [currency in Currency]: number } = {
    [Currency.AUD]: 100,
    [Currency.CAD]: 100,
    [Currency.CHF]: 100,
    [Currency.DKK]: 100,
    [Currency.EUR]: 100,
    [Currency.GBP]: 100,
    [Currency.HKD]: 100,
    [Currency.JPY]: 1,
    [Currency.MXN]: 100,
    [Currency.NOK]: 100,
    [Currency.SGD]: 100,
    [Currency.USD]: 100,
};

export const toSubUnit = (unit: number, currency: Currency): number =>
    unit * unitMultiplier[currency];
export const toUnit = (subUnit: number, currency: Currency): number =>
    subUnit / unitMultiplier[currency];
